import { useEffect, useState } from 'react';

import {
  AddAddressButton,
  AddressFormContainer,
  DeliveryAddress,
  ShowFormattedAddress
} from '@/components/atomic/atoms';
import {
  BottomModal,
  FormValidationErrorMessage,
  InputLabel
} from '@/components/atomic/nuclei';
import { NAME_VALIDATION_CONFIG } from '@/config/common';
import { getCityDetails } from '@/services/city.service';

const AddressModal = ({
  addAddressToggler,
  cityList,
  setUserAddress,
  userAddress
}) => (
  <BottomModal
    paramData={{ setCloseModal: addAddressToggler, showHeader: false }}
  >
    <AddressFormContainer
      {...{
        addAddressToggler,
        cityList,
        setUserAddress,
        userAddress
      }}
    />
  </BottomModal>
);

const CheckoutUserInfo = ({
  currentStep,
  errors,
  register,
  setUserAddress,
  setValue,
  trigger,
  userAddress
}) => {
  const [showAddAddress, setShowAddAddress] = useState(false);
  const [cityList, setCityList] = useState([]);

  const addAddressToggler = () => {
    setShowAddAddress((prevState) => !prevState);
  };

  const gettingCityDetails = async () => {
    const cities = await getCityDetails();
    setCityList(cities.entity);
  };

  useEffect(() => {
    gettingCityDetails();
  }, [currentStep]);

  useEffect(() => {
    if (userAddress?.formattedAddress) {
      setValue('eventAddress', userAddress);
      trigger('eventAddress');
    }
  }, [userAddress, setValue, trigger]);

  return (
    <div className='pt-5 md:pt-8'>
      <div className='pb-5 md:pb-6'>
        <InputLabel
          className='block text-sm md:text-base font-Montserrat text-nero font-medium mb-4'
          required
        >
          Contact Details
        </InputLabel>
        <div className='block md:flex w-full space-y-4 md:space-x-7 md:space-y-0'>
          <div className='w-full md:w-1/2'>
            <input
              {...register('contactName', {
                required: NAME_VALIDATION_CONFIG.nameInputError,
                pattern: {
                  value: NAME_VALIDATION_CONFIG.nameRegex,
                  message: NAME_VALIDATION_CONFIG.nameInputError
                }
              })}
              className={`
                ${
                  errors.contactName
                    ? 'border border-cinnabar animate-shadow-pulse'
                    : 'border-transparent'
                } form-input w-full h-12 px-4 rounded-md border border-gray-300 appearance-none md:max-h-12.5 w-full cursor-pointer placeholder-default text-nero font-medium text-sm leading-5 outline-none p-4 rounded-md shadow-category md:shadow-input md:hover:shadow-list overflow-x-auto`}
              placeholder='Full Name'
            />
            {errors.contactName && (
              <FormValidationErrorMessage
                message={errors.contactName.message}
              />
            )}
          </div>

          <div className='w-full md:w-1/2'>
            <input
              {...register('contactEmail', {
                required: 'Please enter a valid email address.',
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: 'Please enter a valid email address.'
                }
              })}
              className={`
                  ${
                    errors.contactEmail
                      ? 'border border-cinnabar animate-shadow-pulse'
                      : 'border-transparent'
                  } form-input w-full h-12 px-4 rounded-md border border-gray-300 appearance-none md:max-h-12.5 w-full cursor-pointer placeholder-default text-nero font-medium text-sm leading-5 outline-none p-4 rounded-md shadow-category md:shadow-input md:hover:shadow-list overflow-x-auto`}
              placeholder='Email'
            />
            {errors.contactEmail && (
              <FormValidationErrorMessage
                message={errors.contactEmail.message}
              />
            )}
          </div>
        </div>
      </div>

      <div
        className='pb-5 md:pb-6'
        id='contact-address'
      >
        <DeliveryAddress {...{ errors }} />
        {!userAddress.formattedAddress && (
          <AddAddressButton {...{ setShowAddAddress }} />
        )}
        <input
          type='hidden'
          {...register('eventAddress.formattedAddress', {
            required: 'Address is required'
          })}
        />
        {userAddress.formattedAddress && (
          <ShowFormattedAddress
            {...{
              setShowAddAddress,
              userAddress
            }}
          />
        )}
      </div>

      {showAddAddress && (
        <AddressModal
          {...{
            addAddressToggler,
            cityList,
            setUserAddress,
            userAddress
          }}
        />
      )}
    </div>
  );
};

export default CheckoutUserInfo;
